export default "__VITE_ASSET__1q3agtcP__"